import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Copy, Check, X, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useSettings } from "@/lib/settings";
import { EASE } from "@/lib/motion";

export default function PromoBanner() {
  const settings = useSettings();
  const [hidden, setHidden] = useState(() => {
    try {
      return sessionStorage.getItem("tt_banner_hidden") === "1";
    } catch {
      return false;
    }
  });
  const [copied, setCopied] = useState(false);
  const code = (settings.banner_code || "").trim().toUpperCase();
  if (!settings.banner_active || !settings.announcement || hidden) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      toast.success(`Code ${code} copié — collez-le au moment de commander`);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.info(`Votre code : ${code}`);
    }
  };

  const close = () => {
    try {
      sessionStorage.setItem("tt_banner_hidden", "1");
    } catch {}
    setHidden(true);
  };

  return (
    <AnimatePresence>
      <motion.div
        data-testid="promo-banner"
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: EASE }}
        className="fixed top-0 inset-x-0 z-[55] bg-teal-dark text-cream"
      >
        <div className="max-w-6xl mx-auto px-4 h-9 md:h-10 flex items-center justify-center gap-3 text-xs md:text-sm">
          <Sparkles size={14} className="text-mint shrink-0" />
          <p data-testid="promo-banner-text" className="truncate">{settings.announcement}</p>
          {code && (
            <button
              type="button"
              data-testid="promo-banner-code"
              onClick={copy}
              className="inline-flex items-center gap-1.5 rounded-full bg-mint text-teal-dark font-mono font-semibold tracking-wider px-3 py-0.5 hover:bg-white transition-colors"
              aria-label={`Copier le code ${code}`}
            >
              {code} {copied ? <Check size={12} /> : <Copy size={12} />}
            </button>
          )}
          <button type="button" data-testid="promo-banner-close" onClick={close} aria-label="Fermer le bandeau" className="ml-2 text-cream/60 hover:text-cream">
            <X size={14} />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
